import { useState } from 'react';

/** Long model text lives behind a toggle so the visual result stays the main event. */
export function Disclosure({ title, children, defaultOpen = false }: { title: string; children: React.ReactNode; defaultOpen?: boolean }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="card overflow-hidden">
      <button onClick={() => setOpen(!open)} className="flex w-full items-center justify-between px-4 py-3 text-left" aria-expanded={open}>
        <span className="font-cond text-[15px] font-semibold uppercase tracking-[0.08em]">{title}</span>
        <span className={`text-blue transition-transform duration-200 ${open ? 'rotate-90' : ''}`} aria-hidden="true">&rsaquo;</span>
      </button>
      {open && <div className="border-t border-line px-4 py-4 animate-fadeIn">{children}</div>}
    </div>
  );
}
